<ng-container *transloco="let t; read: 'ime.components.saved-filter'">
  <button ngbDropdownItem (click)="saveFilter()">
    {{t('Save filter')}}
  </button>
  <div ngbDropdown class="dropdown-item" container="body">
    <button class="btn btn-link p-0" ngbDropdownToggle>{{t('Saved filters')}}</button>
    <div ngbDropdownMenu>
      <ng-container *ngIf="savedFilters.length; else noFiltersTemplate">
        <button *ngFor="let filter of savedFilters" ngbDropdownItem (click)="open(filter)">
          <span *ngIf="filter.IsShared" class="badge bg-dark">Shared</span>
          {{filter.Text}}
        </button>
      </ng-container>
      <ng-template #noFiltersTemplate>
        <div ngbDropdownItem>
          {{t('No saved filters')}}
        </div>
      </ng-template>
    </div>
  </div>
</ng-container>
